import { useState } from "react";
import { Link } from "react-router-dom";
import { YStack } from "tamagui";

import AuthScaffold, { AuthFooterText, AuthInfoPanel } from "@/components/AuthScaffold";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { AppButton, AppFieldGroup, AppInput, AppText } from "../../ui-foundation";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Please enter your email");
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/update-password`,
    });
    setLoading(false);

    if (error) {
      toast.error(error.message);
      return;
    }

    setSent(true);
  };

  return (
    <AuthScaffold
      eyebrow="Password reset"
      title="We'll help you back in."
      description="Enter your email and we'll send a reset link so you can choose a new password."
    >
      {sent ? (
        <AuthInfoPanel>
          <YStack alignItems="center" gap="$sm">
            <AppText textAlign="center" fontSize="$md" lineHeight="$md">
              We&apos;ve sent a reset link to {email.trim()}. Open it when you&apos;re ready and we&apos;ll help you choose a new password.
            </AppText>
            <Link to="/signin" className="kindred-inline-link">
              Back to sign in
            </Link>
            <Link
              to={`/login-support?email=${encodeURIComponent(email.trim())}`}
              className="kindred-inline-link"
            >
              Reset email not arrived? Get support
            </Link>
          </YStack>
        </AuthInfoPanel>
      ) : (
        <YStack tag="form" onSubmit={handleReset} gap="$sm">
          <AppFieldGroup label={<label htmlFor="email">Email</label>}>
            <AppInput
              id="email"
              type="email"
              value={email}
              onChangeText={setEmail}
              placeholder="you@example.com"
              autoComplete="email"
            />
          </AppFieldGroup>

          <AppButton type="submit" disabled={loading} width="100%">
            {loading ? "Sending..." : "Send reset link"}
          </AppButton>

          <AuthFooterText>
            <Link to="/signin" className="kindred-inline-link">
              Back to sign in
            </Link>
            {" · "}
            <Link
              to={`/login-support${email.trim() ? `?email=${encodeURIComponent(email.trim())}` : ""}`}
              className="kindred-inline-link"
            >
              Need help?
            </Link>
          </AuthFooterText>
        </YStack>
      )}
    </AuthScaffold>
  );
};

export default ResetPassword;
